import * as React from 'react'
import clsx from 'clsx'

import styles from './SectionHead.module.css'

export type SectionHeadProps = {
  title: React.ReactNode
  lede?: React.ReactNode
  /** Title scale: 'md' (default) or 'lg' — a larger display title + ink-colored lede (Press). */
  size?: 'md' | 'lg'
  className?: string
}

/** Shared section heading: a serif display `h2` + an optional sans lede. Used across the static pages. */
export function SectionHead({ title, lede, size = 'md', className }: SectionHeadProps): React.ReactElement {
  return (
    <div className={clsx(styles.head, size === 'lg' && styles.headLg, className)}>
      <h2 className={styles.head__title}>{title}</h2>
      {lede !== undefined ? <p className={styles.head__lede}>{lede}</p> : null}
    </div>
  )
}
